import { DEFAULT_DESKTOP_MODE_MEDIA_QUERY as MUI_DEFAULT_DESKTOP_MODE_MEDIA_QUERY } from '@mui/x-date-pickers-pro';

export const DEFAULT_DESKTOP_MODE_MEDIA_QUERY = MUI_DEFAULT_DESKTOP_MODE_MEDIA_QUERY;
export const DEFAULT_TIME_FORMAT = 'HH:mm';
export const DEFAULT_TIME_STEP = 30;
